<template>
  <div class="parents">
    <!-- <div class="steps">
      <div class="steps_top">
          <img class="steps_bar_size" :src="imagePath+'/order_confirmability.png'"/>
      </div>
    </div> -->
    <div class="prompt">
      <div class="prompt_title">
          <span class="prompt_title_sub">订单详情</span>
      </div>
    </div>

    <!-- <cube-form :model="orderDetails" :schema="schema"></cube-form> -->
    <!-- 车主信息 -->
    <div class="user_info">
      <div class="user_info_item">
        <span class="user_info_title">ETC账户</span>
        <span class="user_info_container">{{orderDetails.daiusername}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title">身份证号</span>
        <span class="user_info_container">{{orderDetails.daiuserIdcard}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title">车牌号码</span>
        <span class="user_info_container">{{orderDetails.plateNum}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title">车牌颜色</span>
        <span class="user_info_container">{{orderDetails.plateColorStr}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title">收费车型</span>
        <span class="user_info_container">{{orderDetails.vehicleType}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title credit">发行机构</span>
        <span class="user_info_container">{{orderDetails.issueName}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title">银行名称</span>
        <span class="user_info_container">{{orderDetails.bankName}}</span>
      </div>
      <div class="user_info_item">
        <span class="user_info_title">银行卡号</span>
        <span class="user_info_container">{{orderDetails.accountNum}}</span>
      </div>
    </div>

    <!-- 收取方式 -->
    <div class="prompt">
      <div class="prompt_title">
          <span class="prompt_title_sub">收取方式</span>
      </div>
    </div>

    
    <div class="select_address">
      <div class="gain_way">
        <div class="expressage" @click=toggleExpress :class="{select_state: expressState == true }">快递</div>
        <div class="fetch" @click=toggleFetch :class="{select_state: fetchState == true }">自取</div>
      </div>
      <!-- 收货人信息 -->
      <div class="user_info_address">
        <!-- 快递信息 -->
        <cube-form v-if="expressState" :model="formData" :schema="schema"></cube-form>

        <!-- 自取 -->
        <div v-if="fetchState">
          <div class="take_name">
            <span class="name">姓名</span>
            <span>{{orderDetails.daiusername}}</span>
          </div>
          <div class="take_mobile">
            <span class="mobile">电话</span>
            <span>{{acquireData.telphoneNo}}</span>
          </div>
        </div>
      </div>
      

      <div class="but_ton">
          <button class="next_btn" v-preventReClick @click="next()">检查无误确认下单</button>
      </div>
    </div>
    <!-- <form class="take" v-if="expressState">
      <div class="take_name">
        <label>姓名</label>
        <input type="text"  v-model="userInfo.name" autofocus="autofocus">
      </div>
      <div class="take_mobile">
        <label>手机号</label>
        <input type="text" v-model="userInfo.mobile">
      </div>
      <div class="take_address">
        <label>收取地址</label>
        <br/>
        <textarea name="" id="" cols="44" rows="5" v-model="userInfo.address"></textarea>
      </div>
    </form> -->

  </div>
</template>

<script>
import { axios } from '../../util/request'
import { log } from 'util'
export default {
  data(){
    return{
      selectOrder:{
          plateNum:sessionStorage.getItem("PLATE-NUM"),
          plateColor:sessionStorage.getItem("PLATE-COLOR"),
          userId:sessionStorage.getItem("USER-ID")
      },
      imagePath: process.env.BASES_IMG_PATH,
      // 选择的状态
      expressState: true,
      fetchState: false,
      // 收货人数据
      // userInfo: {
      //   name:'',
      //   mobile:'',
      //   address:''
      // },
      orderDetails:{
        daiusername:"",
        daiuserIdcard:"",
        plateNum:"",
        plateColorStr:"",
        vehicleType:"",
        issueName:"",
        bankName:"",
        accountNum:"",
      },
      // 快递数据
      formData:{
        userId:sessionStorage.getItem("USER-ID"),
        addressee:"",
        telphoneNo:"",
        direction:"",
      },
      // 自取数据
      acquireData: {
        userId:sessionStorage.getItem("USER-ID"),
        addressee:"",
        telphoneNo:"",
        direction:"自取"
      },
      order:{
        userId:sessionStorage.getItem("USER-ID"),//用户Id
        vehicleId:sessionStorage.getItem("VEHICLE-ID"),//车辆编号
        productId:sessionStorage.getItem("PRODUCT-ID"),//产品id
        name:"",//收货人
        addr:"",//收货地址
        phone:"",//联系电话
        tag:"优惠信息",//优惠标记
        type:1//业务类型
      },

      schema: {
        fields: [          
          {
            type: 'input',
            modelKey: 'addressee',
            label: '收件人',
            props: {
              placeholder:'请输入收件人',
              type: 'String'
            },
            rules: {
              required: true,
            },
            trigger: 'blur'
          },
          {
            type: 'input',
            modelKey: 'telphoneNo',
            label: '收件电话',
            props: {
              placeholder:'请输入手机号',
              type: 'number',
            },
            rules: {
              required: true,
              min:11,
              max:11
            },
            trigger: 'blur',
            messages: {
              required:'手机号不能为空',
              min:'手机号最少11位',
              max:'手机号最多11位'
            }
          },
          {
            type: 'textarea',
            modelKey: 'direction',
            label: '收件地址',
            props: {
              type: 'String',
              placeholder:'请输入收获地址',
              maxlength: 120,
            },
            rules: {
              required: true,
            },
            trigger: 'blur',
          },
          
        ]
      },
    }
  },
  methods:{
    
    next(){
      // 是否为快递状态
      if(this.expressState) {
        // 是否为有效数据
        if (this.formData.addressee.replace(/\s/g,"") && (/^1[3456789]\d{9}$/.test(this.formData.telphoneNo.replace(/\s/g,""))) && this.formData.direction.replace(/\s/g,"")) {
          axios.post("/Address/Add",{
            userId: this.formData.userId,
            addressee: this.formData.addressee.replace(/\s/g,""),
            telphoneNo: this.formData.telphoneNo.replace(/\s/g,""),
            direction: this.formData.direction.replace(/\s/g,""),
          }).then(data=>{
            if(1===data.state){
              this.order.name = this.formData.addressee.replace(/\s/g,"");
              this.order.phone = this.formData.telphoneNo.replace(/\s/g,"");
              this.order.addr = this.formData.direction.replace(/\s/g,"");
  
              console.log(this.order);
              axios.post("/Order/ObuAdd",this.order).then(data=>{
                if(1===data.state){
                  console.log(data);
                  this.$router.push("finish");
                }else{
                  this.showMessage("如果下单失败，请咨询客服！")
                }
              })
            }else{
              this.showMessage("快递信息保存失败，请检查后重新保存。")
            }
          });
        } else {
          this.showMessage('快递信息内容不能为空,或手机号格式错误。');
        }
      } 
      if(this.fetchState) {
        axios.post("/Address/Add",this.acquireData).then(data=>{
          if(1===data.state){
            this.order.name = this.acquireData.addressee;
            this.order.phone = this.acquireData.telphoneNo;
            this.order.addr = this.acquireData.direction;

            console.log(this.order);
            axios.post("/Order/ObuAdd",this.order).then(data=>{
              if(1===data.state){
                console.log(data);
                this.$router.push("finish");
              }else{
                this.showMessage("如果下单失败，请咨询客服！")
              }
            })
          }else{
            this.showMessage("快递信息保存失败，请检查后重新保存。")
          }
        });
      }
      
    },
    // 快递
    toggleExpress() {
      this.expressState = true;
      this.fetchState = false;
    },
    // 自取
    toggleFetch() {
      this.fetchState = true;
      this.expressState = false;
    },
    showMessage(content){
      this.$createDialog({
          type: 'alert',
          title: '提示信息',
          content: content,
          icon: 'cubeic-alert'
      }).show();
    },
  },
  mounted(){
    if(!sessionStorage.getItem('USER-ID')) {
        this.$router.push({name: 'home'});
    } else {
      axios.post("/Order/QueryOrder",this.selectOrder).then(data=>{
        console.log(data);
        // 自取数据赋值
        this.acquireData.addressee = data.daiusername;
        // 数据渲染赋值
        this.orderDetails.daiusername = data.daiusername;
        this.orderDetails.daiuserIdcard = data.daiuserIdcard;
        this.orderDetails.plateNum = data.plateNo;
        this.orderDetails.plateColorStr = data.plateColor;
        this.orderDetails.vehicleType = data.vehicleType;
        this.orderDetails.issueName = data.issueName;
        this.orderDetails.bankName = data.bankName;
        this.orderDetails.accountNum = data.accountNum;
        this.order.vehicleId = data.vehicleId;
        this.order.productId = data.productId;

        if(sessionStorage.getItem('PHONE')) {
          this.acquireData.telphoneNo = sessionStorage.getItem('PHONE');
        } else {
          axios.post("/User/Userinfo", { userId: sessionStorage.getItem("USER-ID") }).then(data => {
            this.acquireData.telphoneNo = data.phone;
          });
        }
      });
    }
  } 
}
</script>

<style lang="less" scoped>
@import '../../assets/styles/varibles.less';
.parents{
  width: calc(100%);
  height: calc(100%);
  margin : 0px;
  // padding : 0px;
  padding-top: 2px;
  background-color: #ffffff;
}
.steps{
  width: calc(100%);
  height: 6rem;
  margin : 0rem auto;
}
.steps_top{
  width: calc(100%);
  height: 4rem;
  padding: 1rem 0 1rem 0;
}
.steps_bar_size {
  width: calc(100%);
  height: calc(100%);
  background : #FEFFFF;
}
.prompt{
  width: calc(100%);
  height : 3rem;
  margin: 1px auto 0;
  // background-color : #EFEFEF;
  background-color: @titleColor;
}
.prompt_title{
  width: calc(100%);
  height : 1rem;
}
.prompt_title_sub{
  width: calc(100%);
  height : 1rem;
  // color: #494949;
  color: #fff;
  font-weight: 500;
  line-height : 1rem;
  display : block;
  margin : 0rem 0 1rem 0;
  padding : 1rem 0 1rem 0;
  text-align : left ;
  text-indent : 1rem;
  font-size: 0.94rem;
}

.user_info {
  width: 100%;
  height: 100%;
  .user_info_item {
    // width: 100%;
    // height: 2.875rem;
    border-bottom: 1px solid #dadada;
    // line-height: 2.875rem;
    text-align: left;
    font-size: 1rem;
    color: #393939;
    .user_info_title {
      display: inline-block;
      margin: 1.125rem 1.25rem 1.125rem 0.94rem;
    }
    .user_info_container {
      display: inline-block;
      height: 100%;
      width: 14.25rem;
      margin-top: 1.125rem;
      margin-bottom: 1.125rem;
    }
    // .credit {
    //   float: left;
    // }
  }
}
.select_address {
  width: 100%;
  height: 100%;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  padding-top: 1rem;
}
.gain_way {
  height: 3rem;
  width: 100%;
  .expressage {
    float: left;
    width: 8rem;
    height: 2.5rem;
    line-height: 2.5rem;
    margin-top: 0.5rem;
    margin-left: 2rem;
    box-sizing: border-box;
    color: #8e8a81;
  }
  .fetch {
    float: left;
    width: 8rem;
    height: 2.5rem;
    line-height: 2.5rem;
    margin-left: 3rem;
    margin-top: 0.5rem;
    box-sizing: border-box;
    color: #8e8a81;
  }
  .select_state {
    color: @titleColor;
  }
}

.user_info_address {
  padding-top: 16px;
  height: 192px;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #fff;
  margin-bottom: 1rem;
  .take_name {
    height: 3rem;
    line-height: 3rem;
    text-align: left;
    color: #393939;
    border-bottom: 1px solid #f8f8f8;
    .name {
      // color: #666;
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
  .take_mobile {
    height: 3rem;
    line-height: 3rem;
    color: #393939;
    text-align: left;
    border-bottom: 1px solid #f8f8f8;
    .mobile {
      // color: #666;
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
}

.cube-form {
  color: #393939;
}

.but_ton{
  width: calc(100%);
  height: 8rem;
  background: #ffffff;
  margin: 0rem auto;
}
.next_btn {
  width: 233px;
  height: 40px;
  text-align: center;
  background-color: #ffffff;
  color: #f18934;
  font-size: 15px;
  font-weight: 400;
  margin-top: 1.56rem;
  border-radius: 20px;
  border:1px solid #f18934;
}

</style>